import { View } from 'react-native';
import { useState } from 'react';

import { useAuth } from '@/hooks/useAuth';
import { Text } from '@/components/Text';
import { Button } from '@/components/ui/therapist/Button';
import Card from '@/components/ui/therapist/Card';
import { User } from '@/stores/store.types';
import { Modal } from '@/components/ui/therapist/Modal';

import { styles } from './styles';

interface HeaderProps {
  user: User;
}

export const Header: React.FC<HeaderProps> = ({ user }) => {
  const { logout } = useAuth();

  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);

  const handleLogout = async () => {
    logout();
    setIsLogoutModalVisible(false);
  };

  return (
    <>
      <Card>
        <View style={styles.itemContainer}>
          <View style={{ flexDirection: 'row' }}>
            <View style={styles.avatar}>
              <Text style={{ fontWeight: 600 }}>
                {user.firstName.charAt(0)} {user.lastName.charAt(0)}
              </Text>
            </View>
            <View>
              <Text style={{ fontSize: 22, fontWeight: 'bold' }}>
                {user.firstName} {user.lastName}
              </Text>
              <Text style={styles.subtext}>Therapeut:in</Text>
            </View>
          </View>
          <Button
            label="Abmelden"
            onPress={() => setIsLogoutModalVisible(true)}
          />
        </View>
      </Card>

      <Modal
        isVisible={isLogoutModalVisible}
        title="Abmelden"
        onClose={() => setIsLogoutModalVisible(false)}
        confirmActionButton={
          <Button label="Abmelden" look="danger" onPress={handleLogout} />
        }
        cancelActionButton={
          <Button
            label="Abbrechen"
            look="secondary"
            onPress={() => setIsLogoutModalVisible(false)}
          />
        }
      >
        <Text>Möchten sie sich wirklich abmelden?</Text>
      </Modal>
    </>
  );
};
